import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "../../../styles/Dashboard.css";
import UserComponent from "./UserComponent";
import EditProfileForm from "./EditProfileForm";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import { handleUpdateUser } from "../../../store/actions/userActions";
import { handleGetUserProfile, handleUpdateUser } from "../../../store/actions/userActions";
import { handleGetFarmersList } from "../../../store/actions/farmersActions";
import { handleGetSuppliersList } from "../../../store/actions/suppliersActions";
import { handleGetConsultantList } from "../../../store/actions/consultantsActions";
// import { handleUpdateUser } from "../store/actions/userActions";
import { handleGetAdminData } from "../../../store/actions/adminActions";
const EditSuperAdminProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { adminList } = useSelector((state) => state.admin);
  const { user, userProfile } = useSelector((state) => state.user);
  const adminId = user?.id;
  const role = user?.role;
  useEffect(() => {
    if (user?.id && !userProfile?.data?.manager) {
      dispatch(handleGetUserProfile(user.id));
    }
  }, [user?.id, userProfile?.data?.manager]);
  
  
  useEffect(() => {
    if (adminId) {
      if (role === "superadmin") {
        dispatch(handleGetAdminData(adminId)); // Fetch admin data for admin users
      } else if (role === "superadmin") {
        // dispatch(handleGetFarmersList()); // Fetch farmers list for superadmin
        // dispatch(handleGetSuppliersList()); // Fetch suppliers list for superadmin
        // dispatch(handleGetConsultantList());
      }
    }
  }, [dispatch, adminId, role]);
console.log('userProfile?.data?.manager?.city', userProfile?.data?.manager?.city);
  //   const { user } = useSelector((state) => state.user);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false); // State to toggle edit mode
  const userData = {
    name: userProfile?.data?.manager?.name || "",
    email: userProfile?.data?.manager?.email || "",
    city: userProfile?.data?.manager?.city || "",
    address: userProfile?.data?.manager?.address || "",
    country: userProfile?.data?.manager?.country || "",
    joinedDate: userProfile?.data?.manager?.created_at || "",
    mobile_number: userProfile?.data?.manager?.mobile_number || "",
    role: userProfile?.data?.manager?.role || "",
  };
  const userDetailsArray = [
    { label: "Name", value: userData.name },
    { label: "Email", value: userData.email },
    { label: "Address", value: userData.address },
    { label: "City", value: userData.city },
    { label: "Country", value: userData.country },
    { label: "Role", value: userData.role },
  ];

  const handleEdit = () => {
    setIsEditing(true); // Set edit mode to true when edit icon is clicked
  };
  const handleFormSubmit = async (updatedData) => {
    try {
      setIsUpdating(true);
  
      await handleUpdateUser(user.id, updatedData, dispatch);
  
      // 🔁 RE-FETCH UPDATED PROFILE
      await handleGetUserProfile(user.id, dispatch);
  
      setIsEditing(false);
    } finally {
      setIsUpdating(false);
    }
  };
  

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          {isEditing ? (
            <EditProfileForm
              user={userData}
              onSubmit={handleFormSubmit}
              onCancel={() => setIsEditing(false)}
              isSubmitting={isSubmitting}
            />
          ) : (
            <UserComponent
              user={userData}
              userDetails={userDetailsArray}
              onEdit={handleEdit}
            />
          )}{" "}
          {/* Toggle view */}
        </Col>
      </Row>
    </Container>
  );
};

export default EditSuperAdminProfile;
